import React, { useState, useEffect } from "react";
import RentalCarCard from "./RentalCarCard";

const AlquilerServicesData = () => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await fetch('/api/rental-cars');
        if (response.ok) {
          const data = await response.json();
          // Expect API response in the format: { cars: [...] }
          const carsData = Array.isArray(data && data.cars) ? data.cars : [];
          if (carsData.length > 0) {
            // Filter only active cars
            const activeCars = carsData.filter(car => car.isActive !== false);
            setCars(activeCars);
          }
        }
      } catch (error) {
        console.error('Error fetching rental cars:', error);
      }
      setLoading(false);
    };

    fetchCars();
  }, []);

  return (
    <div className="rental-section">
      {/* Hero Section */}
      <div className="rental-hero">
        <div className="container">
          <div className="rental-hero__header">
            <span className="rental-hero__badge">
              <i className="fas fa-car"></i>
              Alquiler de Vehículos
            </span>
          </div>
        </div>
      </div>

      {/* Rental Cars Grid */}
      <div className="container">
        {loading ? (
          <div className="rental-loading">
            <div className="rental-loading__spinner"></div>
            <p>Cargando vehículos...</p>
          </div>
        ) : cars.length === 0 ? (
          <div className="rental-empty">
            <i className="fas fa-car" style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }}></i>
            <p style={{ color: '#666', fontSize: '1.1rem' }}>No hay vehículos disponibles actualmente.</p>
          </div>
        ) : (
          <div className="rental-cars-grid">
            {cars.map((car) => (
              <RentalCarCard key={car.slug} car={car} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlquilerServicesData;
